import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MasterImportFormResponseModel } from '../model/MasterImportFormResponseModel';
import { PolImportFormResponseModel } from '../model/PolImportFormResponseModel';

@Injectable({
  providedIn: 'root'
})
export class ImportMasterService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initImportMasterForm() {
    return this.httpClient.get<MasterImportFormResponseModel>(ApiUrls.importMasterInitFormUrl);
  }

  initImportDocumentForm() {
    return this.httpClient.get<PolImportFormResponseModel>(ApiUrls.importLetterrInitFormUrl);
  }
  
  importMaster(lotteryKey: number, type: string, base64: string | ArrayBuffer) {
    return this.httpClient.post<{status: string, errorMessage: string, sucessMessage: string}>(
      ApiUrls.importMasterUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{type}', type.toString()), {
        bas64Data: base64
    });
  }

  importLetter(lotteryKey: number, type: string, base64: string | ArrayBuffer) {
    return this.httpClient.post<{status: string, errorMessage: string, sucessMessage: string}>(
      ApiUrls.importLetterrUrl
      .replace('{lotteryKey}', lotteryKey.toString())
      .replace('{type}', type.toString()), {
        bas64Data: base64
    });
  }

  downloadTemplate(type: string) {
    return this.httpClient.get<{status: string, errorMessage: string, data: string | ArrayBuffer}>(
      ApiUrls.downloadTemplateUrl
      .replace('{type}', type.toString()));
  }
  
  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
